import { combineReducers } from "redux";
import {
    CREATE_USER,
    UPDATE_USER_ENTITY,
    DELETE_USER
} from "../../constants";
import { LOGOUT_USER } from "../../auth/constants";
import { REFRESH_STORE } from "../../app/constants";

export const userById = (state = {}, action) => {
    switch (action.type) {
        case CREATE_USER:
            return { ...state, [action.payload.id]: { ...action.payload } }
        case UPDATE_USER_ENTITY:
            return { ...state, [action.payload.id]: { ...state[action.payload.id], ...action.payload }}
        case DELETE_USER:
            return { ...state, [action.payload.id]: undefined }
        case LOGOUT_USER:
            return {}
        case REFRESH_STORE:
            return {}
        default:
            return state
    }
}

export const userAllIds = (state = [], action) => {
    switch (action.type) {
        case CREATE_USER:
            return [ ...state, action.payload.id ]
        case DELETE_USER:
            return state.reduce((prevState,curId) => curId !== action.payload.id ? [ ...prevState, curId] : prevState,[])
        case LOGOUT_USER:
            return []
        case REFRESH_STORE:
            return []
        default:
            return state
    }
}

export default combineReducers({
    byId: userById,
    allIds: userAllIds
})